
window.Swal = require('sweetalert2/dist/sweetalert2.js').mixin({
    cancelButtonText: 'Zrušit',
    buttonsStyling: false,
    customClass: {
        title: 'font-normal',
        confirmButton: 'btn btn--primary',
        cancelButton: 'btn',
    }
});
